<template>
  <fieldset class="sm:col-span-2">
    <div :class="computedGrid">
      <form-radio
        class="capitalize"
        v-for="({ value, label }, index) in options"
        :key="index"
        :id="`scheduling-for-${value}`"
        :value="value"
        v-model="internalValue"
        @change="onInput"
        >{{ label }}</form-radio
      >
    </div>
  </fieldset>
</template>

<script>
import { FormRadio } from "@/components/Form/";
const OPTIONS = [
  { value: "myself", label: "Myself" },
  { value: "someone-else", label: "Someone else" },
];

export default {
  components: { FormRadio },
  props: ["value", "controls", "grid"],
  data() {
    return {
      internalValue: true,
    };
  },
  computed: {
    computedGrid() {
      if (!this.grid)
        return "grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4";
      if (this.grid === "cols-1") return "grid grid-cols-2 gap-4";
      return this.grid;
    },
    options() {
      return OPTIONS;
    },
    hasLocation() {
      return this.controls?.locations;
    },
    isDisabled() {
      return !this.hasLocation;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>
